import { IChangePasswordRequest, IUser } from '@sdk/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { sdk } from '@/services';

const UserService = sdk.getService('UserService');
const AuthService = sdk.getService('AuthService');

export const useMutateProfile = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['profile'] });
    queryClient.invalidateQueries({ queryKey: ['complete-profile-percentage'] });
  };

  const { mutate: updateProfile, isPending: isUpdating } = useMutation({
    mutationFn: (update: Partial<IUser>) => UserService.updateMe(update),
    onSuccess
  });

  const { mutate: changePassword, isPending: isChanging } = useMutation({
    mutationFn: (passwords: IChangePasswordRequest) => AuthService.changePassword(passwords),
    onSuccess
  });

  const { mutate: switchCurrentAcademy, isPending: isSwitchingCurrentAcademy } = useMutation({
    mutationFn: (academyId: string) => AuthService.switchCurrentAcademy(academyId),
    onSuccess: () => {
      message.success(t('DefaultTranslations:CHANGE_ACADEMY_SUCCESS'));
      setTimeout(() => {
        navigate('/dashboard');
        window.location.reload();
      }, 500);
    }
  });

  return {
    updateProfile,
    changePassword,
    switchCurrentAcademy,
    isWorking: isUpdating || isChanging || isSwitchingCurrentAcademy
  };
};
